import { useEffect, useState } from "react"

import { IClassFilterDraft } from "ts/interfaces/AdminDashboard"

const sameIds = (a: number[], b: number[]) =>
  a.length === b.length && a.every((id) => b.includes(id))

// Picks are staged, so the table refetches once per Apply, not once per tick.
const useClassFilterDraft = (
  applied: number[],
  onApply: (ids: number[]) => void,
): IClassFilterDraft => {
  const [draft, setDraft] = useState(applied)
  // A new filter from anywhere (Apply, Clear filters, dropped ids) replaces the draft.
  useEffect(() => setDraft(applied), [applied.join()])
  return {
    applied,
    draft,
    setDraft,
    isDirty: !sameIds(draft, applied),
    apply: onApply,
    discard: () => setDraft(applied),
  }
}

export default useClassFilterDraft
